import {Injectable} from '@angular/core';
import {BaseApiEndpointService} from '../base-endpoint/base-endpoint.service';
import {ListItem} from '../../types/list-item.type';
import {ServiceProviderHub} from '@generated-backend-types';
import Event = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Eventmanagement.Event.Event;

@Injectable({providedIn: 'root'})
export class EventsService extends BaseApiEndpointService<Event> {
  protected override endpoint = '/events';

  public modelToMultiSelectItem(m: Event): ListItem & {model: Event} {
    return {
      id: m.id,
      text: m.title,
      isDisabled: false,
      model: m,
    };
  }
}
